import { render } from "./Locations.vue?vue&type=template&id=8daabd78&scoped=true"
import script from "./Locations.vue?vue&type=script&lang=js"
export * from "./Locations.vue?vue&type=script&lang=js"

import "./Locations.vue?vue&type=style&index=0&id=8daabd78&scoped=true&lang=css"

import exportComponent from "C:\\Users\\מפתח רוסמן\\Desktop\\Projects\\RosmanNext\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8daabd78"]])

export default __exports__